import { rootApi } from "../../api/rootApi";

export const ecommerceImagesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all folders & image links
    fetchEcommerceImages: builder.mutation({
      query: ({ slug, token }) => ({
        url: `/tenant/ecommerce/images/all`,
        method: "GET",
        headers: {
          slug,
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    // Add new folder with multiple images (multipart/form-data)
    addEcommerceImages: builder.mutation({
      query: ({ slug, token, formData }) => ({
        url: `/tenant/ecommerce/images/add`,
        method: "POST",
        headers: {
          slug,
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }),
    }),
  }),
});

export const {
  useFetchEcommerceImagesMutation,
  useAddEcommerceImagesMutation,
} = ecommerceImagesApi;
